import React, { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

// ========= modules component import section ========= //
import { IconContext } from 'react-icons';
import { MdSettings } from 'react-icons/md';
import moreIcon from '../../../images/more.png';
import * as _ from 'lodash';
import ReactLoading from 'react-loading';
// ====== end of modules component import section ====== //

// ========= project component import section ========= //
import TableHeader from '../components/TableHeader';
// ====== end of project component import section ====== //

// ========= action import section ========= //
import {
  doFetchOfferDetails,
  doFetchMaxAmount,
} from '../../../actions/offerAction';
// ====== end of action import section ====== //

// ========= interface import section ========= //
import DataOfferInterface from '../../../interface/reducers/offer';
import { BidInterface } from '../../../interface/bid';
import { convertToRupiah } from '../../../utils';
import moment from 'moment';
import ModalOffer from '../components/ModalOffer';
// ====== end of interface import section ====== //

const moreIconNew: any = moreIcon;

type stateToProps = {
  dataOffer: DataOfferInterface;
  dataAuth: AuthInterface;
};

interface OfferInterface extends stateToProps {
  doFetchDetails: (bidId: number) => any;
  doFetchBidMaxAmount: (bidId: number) => any;
  callbackAfterUpdate: (...args: any) => any;
  loading: boolean;
  userCurrency: UserCurrencyInterface;
}

import EMPTY_STATE from '../../../images/dashboard-empty-state.jpg';
import {
  accessoriesCondition,
  boxCondition,
  displayItem,
  dustBag,
  formatCurrency,
  handleImageCategory,
  handbagCondition,
  sneakersCondition,
  sneakersDefect,
  yellowing,
  sneakerDefectsCondition
} from '../../../utils/Helpers';
import AuthInterface, {
  UserCurrencyInterface,
} from '../../../interface/reducers/auth';

/**
 * Offer tab on Buying User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {OfferInterface} props for this component.
 * @return {JSX.Element}
 */
function OfferTab({
  dataOffer,
  doFetchBidMaxAmount,
  doFetchDetails,
  callbackAfterUpdate,
  loading,
  userCurrency,
}: OfferInterface): JSX.Element {
  const [isModalOfferOpened, setModalOfferOpened] = useState(false);

  /**
   * Table item for Offer List in Buying Dashboard
   * @param {BidInterface} item
   * @return {JSX.Element}
   */
  function renderItemOffer(item: BidInterface): JSX.Element {
    const isDefects = item?.user_sell?.defects?.length > 0
    const uniqueDefects = _.uniqBy(
      isDefects ? item.user_sell.defects : [], 
      'name'
    );
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'DUST_BAG')
      : {};
    const isExpired = moment(item.expired_at).isBefore(moment());
    const isVintage = item.product_variant.vintage;
    const hideBoxInfo = item.product_variant.hide_box_info

    const sneakersDetailArr = [
      sneakersCondition(item.sneakers_condition),
      hideBoxInfo ? '' : boxCondition(item.box_condition),
      accessoriesCondition(item.missing_accessories),
      yellowing(item.yellowing),
      displayItem(item.display_item),
      sneakersDefect(item.sneakers_defect),
      isDefects ? sneakerDefectsCondition(uniqueDefects) : '',
    ];
    const sneakersDetail = sneakersDetailArr
      .filter((item) => item !== '')
      .map((item) => item)
      .join(' / ');
    const luxuryDetailArr = [
      sneakersCondition(item.sneakers_condition),
      hideBoxInfo ? '' : boxCondition(item.box_condition),
      accessoriesCondition(item.missing_accessories),
      dustBagCondition?.value ? null : dustBag(dustBagCondition),
      isDefects ? handbagCondition(uniqueDefects) : '',
    ];
    const luxuryDetail = luxuryDetailArr
      .filter((item) => item !== '' && item !== 'Missing Box')
      .map((item) => item)
      .join(' / ');
    const handleClickedDetail = () => {
      setModalOfferOpened(true);
      doFetchDetails(item.id);
      doFetchBidMaxAmount(item.id);
    };

    const category = item?.product_variant?.product?.category?.name;
    const isTicket = item?.product_variant?.product?.name.includes('Ticket');

    return (
      <div className={'item-table'}>
        <div className={'product-container offer'}>
          <KickImage
            src={handleImageCategory(isTicket, category.toLowerCase())}
            className={'image-category'}
          />
          <div>
            <p className={'title'}>{item.product_variant.display_name}</p>
            {category === 'handbags' ||
            (category === 'lifestyles' &&
              item.size?.US.toLowerCase() !== 'all size') ? (
              <div className={'size'}>
                <p>{item.size?.US}</p>
              </div>
            ) : (
              <div className={'size'}>
                <p>US {item.size?.US}</p>
              </div>
            )}
            {
              isTicket ?
              <p className={'condition'}>{sneakersCondition(item.sneakers_condition)}</p> :
              <p className={'condition'}>
                {isVintage
                  ? 'Vintage'
                  : item.product_variant.product.category.name !== 'handbags'
                  ? sneakersDetail
                  : luxuryDetail}
              </p>
            }
            <p className={'extra'}>{item?.product_variant?.colour}</p>
            {
              item.pre_order?
              <div className={'pre-order-wrapper'}>
                <p className={'pre-order'}>Pre-Order</p>
              </div> : null
            }
          </div>
        </div>
        <div className={'price-container offer'}>
          <span>
            {formatCurrency(
              item.amount,
              userCurrency.ratio,
              userCurrency.currency,
            )}
          </span>
        </div>
        <div className={'expiry-container offer'}>
          <span className={isExpired ? 'is-expired' : ''}>
            {isExpired
              ? 'Expired'
              : moment(item.expired_at).format('MMMM DD, YYYY')}
          </span>
          <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
            <div className={'icon-container'} onClick={handleClickedDetail}>
              {/* <MdSettings /> */}
              <KickImage src={moreIconNew} alt="..." />
            </div>
          </IconContext.Provider>
        </div>
      </div>
    );
  }

  /**
   * Rendering Empty State UI
   * @return {JSX.Element}
   */
  function renderEmpty() {
    return (
      <div className={'empty-container'}>
        <KickImage src={EMPTY_STATE} />
        <p>It seems you haven’t got anything on offer pending.</p>
        <div className={'button-refresh'} onClick={callbackAfterUpdate}>
          <p>Refresh</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <TableHeader
        getData={callbackAfterUpdate}
        type={'offer'}
        mode={'buying'}
      />
      <div className={'table-container'}>
        <div className={'header-table'}>
          <div className={'product-container'}>
            <span>Product</span>
          </div>
          <div className={'price-container'}>
            <span>Offer Price</span>
          </div>
          <div className={'expiry-container'}>
            <span>Expiry Date</span>
          </div>
        </div>

        <div className={'body-table'}>
          {dataOffer.offerPending.isFetch || loading ? (
            <div className={'empty-container'}>
              <ReactLoading
                type={'spin'}
                height={50}
                width={50}
                color={'#159953'}
              />
            </div>
          ) : dataOffer.offerPending.dataOfferPending.length ? (
            dataOffer.offerPending.dataOfferPending.map((item) =>
              renderItemOffer(item),
            )
          ) : (
            renderEmpty()
          )}
        </div>
      </div>

      <ModalOffer
        isOpen={isModalOfferOpened}
        onToggle={() => setModalOfferOpened(false)}
        callbackAfterUpdate={callbackAfterUpdate}
      />
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataOffer: state.dataOffer,
    userCurrency: state.dataAuth.userCurrency,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doFetchDetails: (bidId: number) => dispatch(doFetchOfferDetails(bidId)),
    doFetchBidMaxAmount: (bidId: number) => dispatch(doFetchMaxAmount(bidId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OfferTab);
